import React from 'react';
import { Divider as MuiDivider } from '@mui/material';

const Divider = (props) => {
  return (
    <MuiDivider {...props} />
  );
};

export default Divider;
